import * as _ from 'lodash';

export class CustomColorTheme {

    public baseColorTheme = null;
    public baseColors = null;
    public headerType = null;
    public id = null;
    public layout = null;
    public name = null;
    public owner = null;
    public updated = null;

    public campaignSectionColors = null;
    public sponsorsColors = null;
    public customThemeAuctionColors = null;
    public fAQSectionColors = null;
    public footerColors = null;
    public generalColors = null;
    public headerColors = null;
    public informationContainerColors = null;
    public orgInfoColors = null;
    public slideShowColors = null;
    public textSectionColors = null;
    public videoColors = null;
    public imageColors = null;

    constructor(customColorTheme) {
        this.baseColorTheme = _.get(customColorTheme, 'baseColorTheme', null);
        this.baseColors = _.get(customColorTheme, 'baseColors', null);
        this.headerType = _.get(customColorTheme, 'headerType', null);
        this.id = _.get(customColorTheme, 'id', null);
        this.layout = _.get(customColorTheme, 'layout', null);
        this.name = _.get(customColorTheme, 'name', null);
        this.owner = _.get(customColorTheme, 'owner', null);
        this.updated = _.get(customColorTheme, 'updated', null);

        const campaignSectionColors = _.get(customColorTheme, 'campaignSectionColors', null);
        this.campaignSectionColors = new CampaignSectionColors(campaignSectionColors);

        const sponsorsColors = _.get(customColorTheme, 'sponsorsColors', null);
        this.sponsorsColors = new SponsorsColors(sponsorsColors);

        const customThemeAuctionColors = _.get(customColorTheme, 'customThemeAuctionColors', null);
        this.customThemeAuctionColors = new CustomThemeAuctionColors(customThemeAuctionColors);

        const fAQSectionColors = _.get(customColorTheme, 'fAQSectionColors', null);
        this.fAQSectionColors = new FAQSectionColors (fAQSectionColors);

        const footerColors = _.get(customColorTheme, 'footerColors', null);
        this.footerColors = new FooterColors(footerColors);

        const generalColors = _.get(customColorTheme, 'generalColors', null);
        this.generalColors = new GeneralColors(generalColors);

        const headerColors = _.get(customColorTheme, 'headerColors', null);
        this.headerColors = new HeaderColors(headerColors);

        const informationContainerColors = _.get(customColorTheme, 'informationContainerColors', null);
        this.informationContainerColors = new InformationContainerColors(informationContainerColors);
        
        const orgInfoColors = _.get(customColorTheme, 'orgInfoColors', null);
        this.orgInfoColors = new OrgInfoColors(orgInfoColors);

        const slideShowColors = _.get(customColorTheme, 'slideShowColors', null);
        this.slideShowColors = new SlideShowColors(slideShowColors);
        
        const textSectionColors = _.get(customColorTheme, 'textSectionColors', null);
        this.textSectionColors = new TextSectionColors(textSectionColors);
        
        const videoColors = _.get(customColorTheme, 'videoColors', null);
        this.videoColors = new VideoColors(videoColors);

        // added videoColors to handle already created custom themes jul 3, 2024
        const imageColors = _.get(customColorTheme, 'imageColors', null) || videoColors;
        this.imageColors = new ImageColors(imageColors);
    }

    getNavBgColor() {
        const navBgColor = _.get(this.headerColors, 'navBgColor', null)
        return navBgColor ? `${navBgColor} !important` : null;
    }

    getNavRegularLinkColor() {
        const navRegularLinkColor = _.get(this.headerColors, 'navRegularLinkColor', null)
        return navRegularLinkColor ? `${navRegularLinkColor} !important` : null;
    }

    setThemeColors() {
        this.campaignSectionColors.setThemeColors();
        this.sponsorsColors.setThemeColors();
        this.customThemeAuctionColors.setThemeColors();
        this.fAQSectionColors.setThemeColors();
        this.footerColors.setThemeColors();
        this.generalColors.setThemeColors();
        this.headerColors.setThemeColors();
        this.informationContainerColors.setThemeColors();
        this.orgInfoColors.setThemeColors();
        this.slideShowColors.setThemeColors();
        this.textSectionColors.setThemeColors();
        this.videoColors.setThemeColors();
        this.imageColors.setThemeColors();
    }
}

export class CampaignSectionColors  {
    public donationCampaignButtonBgColor = null;
    public donationCampaignButtonTextColor = null;
    public donationCampaignSectionBgColor = null;
    public donationCampaignSectionTextColor = null;

    constructor(campaignSectionColors) {
        if(campaignSectionColors === null) {
            return;
        }

        this.donationCampaignButtonBgColor = campaignSectionColors.donationCampaignButtonBgColor;
        this.donationCampaignButtonTextColor = campaignSectionColors.donationCampaignButtonTextColor;
        this.donationCampaignSectionBgColor = campaignSectionColors.donationCampaignSectionBgColor;
        this.donationCampaignSectionTextColor = campaignSectionColors.donationCampaignSectionTextColor;
    }

    setThemeColors() {
        document.documentElement.style.setProperty('--campaign-section-bg', this.donationCampaignSectionBgColor);
        document.documentElement.style.setProperty('--campaign-section-text-color', this.donationCampaignSectionTextColor);
        document.documentElement.style.setProperty('--campaign-section-btn-bg', this.donationCampaignButtonBgColor);
        document.documentElement.style.setProperty('--campaign-section-btn-text', this.donationCampaignButtonTextColor);
    }
}

export class SponsorsColors {
    public sponsorsTitleColor = null;
    public sponsorsTextColor = null;
    public sponsorsBgColor = null;

    constructor(sponsorsColors) {
        if(sponsorsColors === null) {
            return;
        }

        this.sponsorsTitleColor = sponsorsColors.sponsorsTitleColor;
        this.sponsorsTextColor = sponsorsColors.sponsorsTextColor;
        this.sponsorsBgColor = sponsorsColors.sponsorsBgColor;
    }

    setThemeColors() {
        document.documentElement.style.setProperty('--sponsors-section-title-color', this.sponsorsTitleColor);
        document.documentElement.style.setProperty('--sponsors-section-text-color', this.sponsorsTextColor);
        document.documentElement.style.setProperty('--sponsors-section-bg', this.sponsorsBgColor);
    }
}

export class CustomThemeAuctionColors {
    public auctionBgColor = null;
    public auctionTextColor = null;

    constructor(customThemeAuctionColors) {
        if(customThemeAuctionColors === null) {
            return;
        }

        this.auctionBgColor = customThemeAuctionColors.auctionBgColor;
        this.auctionTextColor = customThemeAuctionColors.auctionTextColor;
    }

    setThemeColors() {
        document.documentElement.style.setProperty('--auction-section-title-color', this.auctionTextColor);
        document.documentElement.style.setProperty('--auction-section-bg', this.auctionBgColor);
    }
}

export class FAQSectionColors {

    public faqSectionBgColor = null;
    public faqSectionItemTextBgColor = null;
    public faqSectionItemTextColor = null;
    public faqSectionTitleColor = null;

    constructor(fAQSectionColors) {
        if(fAQSectionColors === null) {
            return;
        }

        this.faqSectionBgColor = fAQSectionColors.faqSectionBgColor;
        this.faqSectionItemTextBgColor = fAQSectionColors.faqSectionItemTextBgColor;
        this.faqSectionItemTextColor = fAQSectionColors.faqSectionItemTextColor;
        this.faqSectionTitleColor = fAQSectionColors.faqSectionTitleColor;
    }

    setThemeColors() {
        document.documentElement.style.setProperty('--faq-section-bg', this.faqSectionBgColor);
        document.documentElement.style.setProperty('--faq-section-item-bg', this.faqSectionItemTextBgColor);
        document.documentElement.style.setProperty('--faq-section-title-color', this.faqSectionTitleColor);
        document.documentElement.style.setProperty('--faq-section-item-text-color', this.faqSectionItemTextColor);
    }
}

export class FooterColors {

    public footerBgColor = null;
    public footerTextColor = null;

    constructor(footerColors) {
        if(footerColors === null) {
            return;
        }

        this.footerBgColor = footerColors.footerBgColor;
        this.footerTextColor = footerColors.footerTextColor;
    }

    setThemeColors() {
        document.documentElement.style.setProperty('--footer-text-color', this.footerTextColor);
        document.documentElement.style.setProperty('--footer-bg-color', this.footerBgColor);
    }
}

export class GeneralColors {

    public pageBgColor = '#FFFFFF';

    constructor(generalColors) {
        this.pageBgColor = _.get(generalColors, 'pageBgColor', '#FFFFFF');
    }

    setThemeColors() {
        document.documentElement.style.setProperty('--base-color', this.pageBgColor);
    }
}

export class HeaderColors {

    public navActiveLinkColor = null;
    public navBgColor = null;
    public navRegularLinkColor = null;

    constructor(headerColors) {
        if(headerColors === null) {
            return;
        }

        this.navActiveLinkColor = headerColors.navActiveLinkColor;
        this.navBgColor = headerColors.navBgColor;
        this.navRegularLinkColor = headerColors.navRegularLinkColor;
    }

    setThemeColors() {
        document.documentElement.style.setProperty('--header-section-bg', this.navBgColor);
        document.documentElement.style.setProperty('--header-section-nav-item-regular-color', this.navRegularLinkColor);
        document.documentElement.style.setProperty('--header-section-nav-item-active-color', this.navActiveLinkColor);
    }
}

export class InformationContainerColors {

    public informationContainerBg = '';
    public informationContainerButtonBgColor = '';
    public informationContainerButtonTextColor = '';
    public informationContainerDateColor = '';
    public informationContainerRightTriangleBgColor = '';
    public informationContainerShareIconsTextColor = '';
    public informationContainerTextColor = '';

    constructor(informationContainerColors) {
        if(informationContainerColors === null) {
            return;
        }

        this.informationContainerBg = informationContainerColors.informationContainerBg;
        this.informationContainerButtonBgColor = informationContainerColors.informationContainerButtonBgColor;
        this.informationContainerButtonTextColor = informationContainerColors.informationContainerButtonTextColor;
        this.informationContainerDateColor = informationContainerColors.informationContainerDateColor;
        this.informationContainerRightTriangleBgColor = informationContainerColors.informationContainerRightTriangleBgColor;
        this.informationContainerShareIconsTextColor = informationContainerColors.informationContainerShareIconsTextColor;
        this.informationContainerTextColor = informationContainerColors.informationContainerTextColor;
    }

    setThemeColors() {
        document.documentElement.style.setProperty('--information-container-right-triangle-bg', this.informationContainerRightTriangleBgColor);
        document.documentElement.style.setProperty('--information-container-button-text', this.informationContainerButtonTextColor);
        document.documentElement.style.setProperty('--information-container-button-bg', this.informationContainerButtonBgColor);
        document.documentElement.style.setProperty('--information-container-share-icons-text', this.informationContainerShareIconsTextColor);
        document.documentElement.style.setProperty('--information-container-date-color', this.informationContainerDateColor);
        document.documentElement.style.setProperty('--information-container-bg', this.informationContainerBg);
        document.documentElement.style.setProperty('--information-container-text-color', this.informationContainerTextColor);
    }
}

export class OrgInfoColors {

    public orgInfoBgColor = null;
    public orgInfoTextColor = null;

    constructor(orgInfoColors) {
        if(orgInfoColors === null) {
            return;
        }

        this.orgInfoBgColor = orgInfoColors.orgInfoBgColor;
        this.orgInfoTextColor = orgInfoColors.orgInfoTextColor;
    }

    setThemeColors() {
        document.documentElement.style.setProperty('--org-info-text-color', this.orgInfoTextColor);
        document.documentElement.style.setProperty('--org-info-bg', this.orgInfoBgColor);
    }
}

export class SlideShowColors {

    public slideShowBgColor = null;
    public slideShowTextColor = null;

    constructor(slideShowColors) {
        if(slideShowColors === null) {
            return;
        }

        this.slideShowBgColor = slideShowColors.slideShowBgColor;
        this.slideShowTextColor = slideShowColors.slideShowTextColor;
    }

    setThemeColors() {
        document.documentElement.style.setProperty('--slide-bg', this.slideShowBgColor);
        document.documentElement.style.setProperty('--slide-text-color', this.slideShowTextColor);
    }
}

export class TextSectionColors {

    public textSectionBgColor = null;
    public textSectionTextColor = null;
    public textSectionTitleColor = null;

    constructor(textSectionColors) {
        if(textSectionColors === null) {
            return;
        }

        this.textSectionBgColor = textSectionColors.textSectionBgColor;
        this.textSectionTextColor = textSectionColors.textSectionTextColor;
        this.textSectionTitleColor = textSectionColors.textSectionTitleColor;
    }

    setThemeColors() {
        document.documentElement.style.setProperty('--text-section-bg', this.textSectionBgColor);
        document.documentElement.style.setProperty('--text-section-title-color', this.textSectionTitleColor);
        document.documentElement.style.setProperty('--text-section-text-color', this.textSectionTextColor);
    }
}

export class VideoColors {
    public videoSectionBgColor = null;
    public videoSectionTextColor = null;

    constructor(videoColors) {
        if(videoColors === null) {
            return;
        }
        
        this.videoSectionBgColor = videoColors.videoSectionBgColor;
        this.videoSectionTextColor = videoColors.videoSectionTextColor;
    }

    setThemeColors() {
        document.documentElement.style.setProperty('--video-section-bg', this.videoSectionBgColor);
        document.documentElement.style.setProperty('--video-section-text-color', this.videoSectionTextColor);
    }
}

export class ImageColors {
    public imageSectionBgColor = null;
    public imageSectionTextColor = null;

    constructor(imageColors) {
        if(imageColors === null) {
            return;
        }

        if(imageColors.videoSectionBgColor || imageColors.videoSectionTextColor) {
            this.imageSectionBgColor = imageColors.videoSectionBgColor;
            this.imageSectionTextColor = imageColors.videoSectionTextColor;
            return;
        }
        
        this.imageSectionBgColor = imageColors.imageSectionBgColor;
        this.imageSectionTextColor = imageColors.imageSectionTextColor;
    }

    setThemeColors() {
        document.documentElement.style.setProperty('--image-section-bg', this.imageSectionBgColor);
        document.documentElement.style.setProperty('--image-section-text-color', this.imageSectionTextColor);
    }
}
